/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/

import React from "react"
import educatorThumb from "../images/educatorThumb.jpg"
import importanceThumb from "../images/importanceThumb.jpg"
const posts = [
  {
    title: "SDG Website",
    href: "https://sdgs.un.org/about ",
    description:
      "The Division for Sustainable Development Goals (DSDG) in the United Nations Department of Economic and Social Affairs (UNDESA) acts as the Secretariat for the SDGs, providing substantive support and capacity-building for the goals and their related thematic issues, including water, energy, climate, oceans, urbanization, transport, science and technology, the Global Sustainable Development Report (GSDR), partnerships and Small Island Developing States.",
    date: "Mar 16, 2020",
    datetime: "2020-03-16",
  },
  {
    title: "WASH in Schools (WinS)",
    href: "https://wins.deped.gov.ph/#:~:text=The%20DepEd%20WinS%20Program%20is,conditions%20that%20would%20hamper%20their",
    description:
      "The DepEd WinS Program is designed to achieve learning and health outcomes of Filipino students through a comprehensive, sustainable, and scalable school-based WASH program pursuant to the State’s mandate to defend the right of children to dignity, assistance, and protection from conditions that would hamper their development.",
    date: "Feb 12, 2020",
    datetime: "2020-02-12",
  },
  {
    title: "Testimonial: WASHEd Educator Experience",
    href: "https://www.youtube.com/watch?v=SlFX_sObmPg",
    description: "",
    date: "Jan 29, 2020",
    datetime: "2020-01-29",
    image: educatorThumb,
  },
  {
    title: "Testimonial: The Importance of the Program",
    href: "https://www.youtube.com/watch?v=9ILjWGJdsQQ&t=28s",
    description: "",
    date: "Jan 29, 2020",
    datetime: "2020-01-29",
    image: importanceThumb,
  },
]

export default function ResourcesContent() {
  return (
    <div className="bg-white pt-12 pb-20 px-4 sm:px-6 lg:pb-28 lg:px-8">
      <div className="relative max-w-lg mx-auto divide-y-2 divide-gray-200 lg:max-w-7xl">
        <div>
          <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
            Resources
          </h2>
          <div className="mt-3 sm:mt-4 lg:grid lg:grid-cols-2 lg:gap-5 lg:items-center">
            {/* <p className="text-xl text-gray-500">Get weekly articles in your inbox on how to grow your business.</p> */}
          </div>
        </div>
        <div className="mt-6 pt-10 grid gap-16 lg:grid-cols-2 lg:gap-x-5 lg:gap-y-12">
          {posts.map(post => (
            <div key={post.title}>
              {/* <p className="text-sm text-gray-500">
                  <time dateTime={post.datetime}>{post.date}</time>
                </p> */}
              <a href={post.href} className="mt-2 block" target="_blank">
                <p className="text-xl font-semibold text-gray-900">
                  {post.title}
                </p>
                <p className="mt-3 text-base text-gray-500">
                  {post.description}
                </p>
                {post.image && (
                  <img
                    className="w-3/4 justify-center"
                    src={post.image}
                    alt=""
                  />
                  // <h1>post</h1>
                )}
              </a>
              <div className="mt-3">
                <a
                  href={post.href}
                  className="text-base font-semibold text-indigo-600 hover:text-indigo-500"
                >
                  Visit this resource
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
